<template>
    <div class="spark-docs-banner">
        <div class="spark-docs-banner__content">
            <div class="content__title">Spark Docs</div>

            <div class="content__description">
                <p>Будьте первыми!</p>
                <p>Полгода бесплатно – начните уже сегодня!</p>
            </div>
        </div>

        <img class="spark-docs-banner__img" alt="Spark Docs" src="/banners/spark-docs-banner-2.png" draggable="false" />
    </div>
</template>